import { SUBJECTS, formatDay, subjectTotal } from './studyDashboard';

const count = (value) => new Intl.NumberFormat('tr-TR').format(value);

export function studentFeedback(student, dates, today, subjects = SUBJECTS) {
  const elapsed = dates.filter((date) => date <= today);
  const recorded = new Set(student.records.map((record) => record.date));
  const completed = elapsed.filter((date) => date < today);
  let gap = 0;
  for (let i = completed.length - 1; i >= 0 && !recorded.has(completed[i]); i -= 1) gap += 1;
  const last = [...recorded].sort().at(-1);
  const books = student.completed_books?.length || 0;
  const coverage = `${count(elapsed.length)} günün ${count(recorded.size)} gününde çalışma kaydı var.`;
  const values = subjects.map(([key, label]) => ({ label, value: subjectTotal(student.records, key) }));
  const max = Math.max(0, ...values.map(({ value }) => value));
  const leaders = values.filter(({ value }) => value === max).map(({ label }) => label);
  const classified = values.reduce((sum, { value }) => sum + value, 0);
  let activity = recorded.size ? `Kayıtlarda ${count(student.questions)} soru ve ${count(student.pages)} sayfa bulunuyor.` : '';
  if (max > 0) activity += ` En çok soru kaydı ${leaders.join(' ve ')} ${leaders.length > 1 ? 'derslerinde ayrı ayrı' : 'dersinde'} ${count(max)} soru.`;
  if (student.questions > classified) activity += ` ${count(student.questions - classified)} sorunun ders bilgisi yok.`;
  if (books) activity += ` ${count(books)} kitap tamamlanmış.`;

  if (!recorded.size) return {
    tone: 'blue', title: 'Çalışma kayıtlarını birlikte gözden geçirin',
    summary: `Seçilen ${count(elapsed.length)} günlük aralıkta çalışma kaydı bulunmuyor.`, activity: activity.trim(),
    nextStep: 'Öğrenciyle bu aralıktaki çalışma planını konuşup kayıtların girilip girilmediğini teyit edebilirsiniz.',
  };
  if (gap >= 3) return {
    tone: 'orange', title: 'Son günlerin kayıtlarını kontrol edin',
    summary: `${coverage} Aralığın son ${count(gap)} tamamlanmış gününde kayıt yok; son kayıt ${formatDay(last)}.`, activity,
    nextStep: 'Kayıt olmayan günlerdeki çalışmaları öğrenciyle teyit edip günlük kayıt alışkanlığını destekleyebilirsiniz.',
  };
  if (recorded.size === elapsed.length && elapsed.length > 1) return {
    tone: 'green', title: 'Kayıtlar düzenli ilerliyor', summary: coverage, activity,
    nextStep: max > 0 && leaders.length === 1
      ? `Kayıt düzenini pekiştirip ${leaders[0]} dışındaki derslerin çalışma planındaki yerini birlikte gözden geçirebilirsiniz.`
      : 'Kayıt düzenini pekiştirip bir sonraki çalışma hedefini öğrenciyle birlikte belirleyebilirsiniz.',
  };
  return {
    tone: 'blue', title: 'Çalışma planını kayıtlarla değerlendirin',
    summary: `${coverage} Son kayıt ${formatDay(last)}.`, activity,
    nextStep: recorded.size < elapsed.length
      ? 'Kayıt olmayan günleri öğrenciyle birlikte gözden geçirip uygulanabilir bir günlük çalışma hedefi belirleyebilirsiniz.'
      : 'Bu günün çalışmasını öğrenciyle değerlendirip bir sonraki çalışma hedefini birlikte belirleyebilirsiniz.',
  };
}
